'use client';

import { demoCredentials } from './demoData';
import type { DemoRole, DemoSession } from './demoTypes';

const SESSION_KEY = 'gymos.demo.session.v1';

export function getCurrentUser(): DemoSession | null {
  if (typeof window === 'undefined') return null;
  const stored = window.localStorage.getItem(SESSION_KEY);
  if (!stored) return null;
  try { return JSON.parse(stored) as DemoSession; } catch { return null; }
}

function persist(session: DemoSession): DemoSession {
  window.localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  return session;
}

export function loginStudent(dni: string): DemoSession | null {
  if (dni !== demoCredentials.student.dni) return null;
  return persist({ userId: 'member-001', memberId: 'member-001', role: 'student', name: demoCredentials.student.label });
}

export function loginStaff(role: Extract<DemoRole, 'professor' | 'admin'>, email: string, password: string): DemoSession | null {
  const credentials = demoCredentials[role];
  if (email.toLowerCase() !== credentials.email || password !== credentials.password) return null;
  return persist({ userId: role === 'admin' ? 'admin-001' : 'prof-001', role, name: credentials.label, email: credentials.email });
}

export function logout(): void {
  if (typeof window !== 'undefined') window.localStorage.removeItem(SESSION_KEY);
}
